import {ACTION_CODE} from './_actionCode';
import { ContractsService } from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
import { GetAllContractsSchemaType } from '../../services/contractsService/_schema/getAllContracts.schema';
const FUNCTION_CODE = 'GET_ALL_CONTRACTS';

export async function getAllContracts(
    token: '',
    params: '',
    page: 1
) {
    try {
        LoggerService.logInfo('Action - getAllContracts - Start');

        const result = await ContractsService.getAllContracts(token, params, page);

        const {data, metadata} = result;

        LoggerService.logInfo('Action - getAllContracts - End - Success');

        return ResultModel.newSuccessResultTyped<GetAllContractsSchemaType>(data, metadata);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllContracts - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation des contrats',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
